import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_MAINTENANCE_TYPES](state, data) {
    console.log('mutation ', data)
    state.allMaintenanceTypes = data
  },
}
